import { useState, useContext } from 'react'
import { useNavigate } from "react-router-dom"
import { enqueueSnackbar } from 'notistack'

import { ButtonGroup, Button } from '@mui/material'

import { AppContext } from '/providers/app-context'
import { unarchiveTemplate } from '/providers/templates-api'

import ArchiveDialog from './archive-dialog'
import SynchroniseDialog from './synchronise-dialog'
import NotifyAllDialog from './notify-all-dialog'

const Menu = ({ template, processing, setProcessing }) => {
  const { apiSource, apiKey, refreshTemplates } = useContext(AppContext)

  const [syncOpen, setSyncOpen] = useState(false)
  const [archiveOpen, setArchiveOpen] = useState(false)
  const [notifyOpen, setNotifyOpen] = useState(false)

  const navigate = useNavigate()
  const page = location.pathname.split("/").pop()

  if (template) {
    const unarchive = async () => {
      enqueueSnackbar({ message: 'un-archiving template', variant: 'light' })
      await unarchiveTemplate({ apiSource, apiKey, templateId: template.id })
      // TODO handler error
      enqueueSnackbar({ message: 'template un-archived', variant: 'success' })
      refreshTemplates(template.id)
      navigate("/templates/" + template.id)
    }


    if (template.archived) return (
      <div className='flex flex-row justify-end whitespace-nowrap'>
        <Button onClick={unarchive} variant='text'>Un-archive</Button>
      </div>
    )

    if (template.wizardpermitted) return (
      <>
        <div className='flex flex-row justify-end whitespace-nowrap'>
          <ButtonGroup variant="text" aria-label="Actions">
            <Button onClick={() => navigate("../details")} sx={{ color: page === "details" ? "link" : "text.secondary" }}>Details</Button>
            <Button onClick={() => navigate("../wizard")} sx={{ color: page === "edit" ? "link" : "text.secondary" }}>Setup Wzard</Button>
            <Button onClick={() => setArchiveOpen(true)} sx={{ color: "text.secondary" }}>Archive</Button>
          </ButtonGroup>
        </div>

        <ArchiveDialog open={archiveOpen} setOpen={setArchiveOpen} template={template} processing={processing} setProcessing={setProcessing} />
      </>
    )

    return (
      <>
        <div className='flex flex-row justify-end whitespace-nowrap'>
          <ButtonGroup variant="text" aria-label="Actions">
            <Button onClick={() => navigate("../details")} sx={{ color: page === "details" ? "link" : "text.secondary" }}>Details</Button>
            <Button onClick={() => navigate("../edit")} sx={{ color: page === "edit" ? "link" : "text.secondary" }}>Edit</Button>
            <Button onClick={() => navigate("../duplicate")} sx={{ color: page === "duplicate" ? "link" : "text.secondary" }}>Duplicate</Button>
            <Button onClick={() => navigate("../issue-passes")} sx={{ color: page === "issue-passes" ? "link" : "text.secondary" }}>Issue New Passes</Button>
            <Button onClick={() => navigate("../passes")} sx={{ color: page === "passes" ? "link" : "text.secondary" }}>List Passes</Button>
            <Button onClick={() => navigate("../stats")} sx={{ color: page === "stats" ? "link" : "text.secondary" }}>Stats</Button>
            {template.smartix_scanner && 
              <Button onClick={() => navigate("../scan-reports")} sx={{ color: page === "can-reports" ? "link" : "text.secondary" }}>Scan Reports</Button>
            }            
            <Button onClick={() => setNotifyOpen(true)} sx={{ color: "text.secondary" }}>Notify All</Button>
            <Button onClick={() => setSyncOpen(true)} sx={{ color: "text.secondary" }}>Synchronise</Button>
            <Button onClick={() => setArchiveOpen(true)} sx={{ color: "text.secondary" }}>Archive</Button>
          </ButtonGroup>
        </div>

        <ArchiveDialog open={archiveOpen} setOpen={setArchiveOpen} template={template} processing={processing} setProcessing={setProcessing} />
        <SynchroniseDialog open={syncOpen} setOpen={setSyncOpen} template={template} processing={processing} setProcessing={setProcessing} />
        <NotifyAllDialog open={notifyOpen} setOpen={setNotifyOpen} template={template} processing={processing} setProcessing={setProcessing} />
      </>
    )
  }
}

export default Menu